// tslint:disable
export enum LocationCorrection {
    /**
     * @description LACSLink conversion
     */
    LacsLinkConversion = 1,
    /**
     * @description Derived primary number
     */
    DerivedPrimaryNumber = 2,
    /**
     * @description City name determined by ZIP4 alternate
     */
    CityDerivedFromZip4Alternate = 3,
    /**
     * @description Street name changed to preferred alias
     */
    StreetNameChanged = 4,
    /**
     * @description Input ZIP4 retained
     */
    Zip4Retained = 8,
    /**
     * @description Directional or Suffix changed
     */
    DirectionalOrSuffixChanged = 9,
    /**
     * @description City changed
     */
    CityChanged = 10,
    /**
     * @description Added unit designator and secondary number
     */
    AddedUnitAndSecondaryNumber = 11,
    /**
     * @description Implied city based on ZIP
     */
    CityDerivedFromZip = 12,
    /**
     * @description Modified primary or secondary number
     */
    ModifiedPrimaryOrSecondaryNumber = 13,
    /**
     * @description Pre or post directional change
     */
    PreOrPostDirectionalChange = 15,
    /**
     * @description City name changed
     */
    CityNameChanged = 17,
    /**
     * @description Street suffix changed
     */
    StreetSuffixChanged = 18,
    /**
     * @description Directional shift
     */
    DirectionalShift = 19,
    /**
     * @description ZIP code changed
     */
    ZipChanged = 22,
    /**
     * @description State changed
     */
    StateChanged = 23,
    /**
     * @description Swapped Line 1 and Line 2
     */
    SwappedLine1AndLine2 = 30,
    /**
     * @description Dropped invalid info in Line 2
     */
    DroppedInvalidLine2 = 31,
}
(LocationCorrection as any)['LACSLINKCONVERSION'] = 1;
(LocationCorrection as any)['DERIVEDPRIMARYNUMBER'] = 2;
(LocationCorrection as any)['CITYDERIVEDFROMZIP4ALTERNATE'] = 3;
(LocationCorrection as any)['STREETNAMECHANGED'] = 4;
(LocationCorrection as any)['ZIP4RETAINED'] = 8;
(LocationCorrection as any)['DIRECTIONALORSUFFIXCHANGED'] = 9;
(LocationCorrection as any)['CITYCHANGED'] = 10;
(LocationCorrection as any)['ADDEDUNITANDSECONDARYNUMBER'] = 11;
(LocationCorrection as any)['CITYDERIVEDFROMZIP'] = 12;
(LocationCorrection as any)['MODIFIEDPRIMARYORSECONDARYNUMBER'] = 13;
(LocationCorrection as any)['PREORPOSTDIRECTIONALCHANGE'] = 15;
(LocationCorrection as any)['CITYNAMECHANGED'] = 17;
(LocationCorrection as any)['STREETSUFFIXCHANGED'] = 18;
(LocationCorrection as any)['DIRECTIONALSHIFT'] = 19;
(LocationCorrection as any)['ZIPCHANGED'] = 22;
(LocationCorrection as any)['STATECHANGED'] = 23;
(LocationCorrection as any)['SWAPPEDLINE1ANDLINE2'] = 30;
(LocationCorrection as any)['DROPPEDINVALIDLINE2'] = 31;
